import axios from 'axios'

export default {

    /**
     * @desc Create a news post for a group
     * @param {Object} post_data
     * @param {boolean} isMockStudent
     * @return {Promise} response
     */
    async createNewPost(post_data, isMockStudent = false) {
        // Handle real user
        if (!isMockStudent) return await axios.post('/post', post_data)

        const currentDate = Date.now()

        // Mock response
        return {
            data: {
                ...post_data,
                assignment_id: '0',
                comments: [],
                edit_date: '0',
                firstname: 'Student',
                group_material_element_id: '0',
                lastname: 'Testing',
                post_date: currentDate / 1000,
                post_id: currentDate,
                post_status: 'public',
                profile_picture_url: '',
                mock_identifier: true,
            },
        }
    },

    /**
     * @desc Edit a group news post
     * @param {number} post_id
     * @param {Object} post_data
     * @param {boolean} isMockStudent
     * @return {Promise} response
     */
    async editPost(post_id, post_data, isMockStudent = false) {
        if (!isMockStudent) return await axios.put(`/post/${post_id}`, post_data)

        // Mock response
        return {}
    },

    /**
     * @desc Attach already-uploaded media to an existing post without
     *       re-saving the post body. Used by DirectEdit so a correction
     *       attached to an ALREADY-SAVED feedback persists immediately
     *       instead of living only in component state until the next save
     *       (which, for a second document, never came).
     * @param {number} post_id
     * @param {Array<number>} media_ids
     * @return {Promise} response
     */
    async attachMediaToPost(post_id, media_ids) {
        return await axios.post(`/post/${post_id}/attachments`, { media_ids })
    },

    /**
     * @desc Detach one media row from a post. The inverse of
     *       attachMediaToPost — the post-save path only ever adds.
     * @param {number} post_id
     * @param {number} media_id
     * @return {Promise} response
     */
    async detachMediaFromPost(post_id, media_id) {
        return await axios.delete(`/post/${post_id}/attachments/${media_id}`)
    },

    async pinPost({ post_id, pinned }) {

        return await axios.put(`/post/pinned/${post_id}`, {
            pinned : pinned
        })

    },

    async updatePostStatus(post_id, post_status) {
        return await axios.put(`/post/status/${post_id}`, { post_status })
    },

    /**
     * @desc Delete a news post from a group
     * @param {number} post_id
     * @param {boolean} isMockStudent
     * @return {Promise} response
     */
    async removePost(post_id, isMockStudent = false) {
        // Handle real user
        if (!isMockStudent) return await axios.delete(`/post/${post_id}`)

        // Mock response
        return {}
    },
}
